import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path d="m3 20 9-16 9 16zm9-10v4.5m0 1.5v2" stroke={color} strokeWidth="2" fill="none" fillRule="evenodd" />
  </svg>
);
